import { ReactNode, Ref } from 'react';
import { FieldError, Group, Input, Label, Text } from 'react-aria-components';
import { VariantProps } from 'tailwind-variants';

import { styles } from './UiKitInputSearch.styles';

type InputProps = React.ComponentPropsWithoutRef<typeof Input>;
type BaseInputProps = Omit<InputProps, 'isInvalid'>;

export type Type = VariantProps<typeof styles>['type'];

export interface UiKitInputSearchProps extends BaseInputProps {
  label?: string;
  helperText?: string;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  errorMessage?: string;
  ref?: Ref<HTMLDivElement>;
  className?: string;
  classNameWrapper?: string;
  type?: Type;
  withBorder?: boolean;
  error?: boolean;
  onSearch?: (query: string) => void;
}

export function UiKitInputSearch({
  startAdornment,
  endAdornment,
  label,
  helperText,
  errorMessage,
  ref,
  className,
  classNameWrapper,
  withBorder = true,
  error,
  onSearch,
  type,
  ...props
}: UiKitInputSearchProps) {
  const slots = styles({
    error,
    withBorder,
    type
  });

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(e.currentTarget.value);
    }
    props.onKeyDown?.(e);
  };

  return (
    <>
      {label && <Label className={slots.label()}>{label}</Label>}
      <Group
        className={slots.wrapper({ className: classNameWrapper })}
        ref={ref}
      >
        {startAdornment && (
          <div className={slots.startAdornment()}>{startAdornment}</div>
        )}
        <Input
          className={slots.input({ class: className })}
          {...props}
          onKeyDown={handleKeyDown}
        />
        {endAdornment && (
          <div className={slots.endAdornment()}>{endAdornment}</div>
        )}
      </Group>
      {helperText && (
        <Text
          slot="description"
          className={slots.helperText()}
        >
          {helperText}
        </Text>
      )}
      <FieldError>{errorMessage}</FieldError>
    </>
  );
}
